{
  "chart": "病人病歷",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "基本資料",
    "loading": "正在載入病人基本資料...",
    "loadError": "載入病人基本資料失敗。",
    "returnToDashboard": "返回主頁",
    "updatedSuccess": "病人基本資料已更新",
    "updateError": "更新病人基本資料失敗",
    "sections": {
      "personalInformation": "個人資料",
      "identification": "身份證明",
      "contactInformation": "聯絡資料",
      "address": "地址",
      "languageAndPreferences": "語言及偏好",
      "specialFlags": "特別標記",
      "recordInformation": "紀錄資料"
    },
    "fields": {
      "fullName": "姓名",
      "alternativeName": "別名",
      "preferredName": "慣用名稱",
      "dateOfBirth": "出生日期",
      "birthTime": "出生時間",
      "age": "年齡",
      "legalGender": "法定性別",
      "genderIdentity": "性別認同",
      "sexAtBirth": "出生時性別",
      "race": "種族",
      "ethnicity": "族裔",
      "nationality": "國籍",
      "mrn": "MRN",
      "nationalIdType": "證件類型",
      "nationalIdNumber": "證件號碼",
      "passportNumber": "護照號碼",
      "passportCountry": "護照簽發地",
      "primaryPhone": "主要電話",
      "mobilePhone": "手提電話",
      "email": "電郵",
      "preferredContactMethod": "首選聯絡方式",
      "addressLine1": "地址第一行",
      "addressLine2": "地址第二行",
      "city": "城市",
      "stateProvince": "省/州",
      "postalCode": "郵政編碼",
      "country": "國家/地區",
      "primaryLanguage": "主要語言",
      "secondaryLanguage": "次要語言",
      "interpreterRequired": "需要傳譯員",
      "vipStatus": "VIP 狀態",
      "confidentialityLevel": "保密級別",
      "medicalTourist": "醫療旅客",
      "homeCountry": "原居地",
      "status": "狀態",
      "deceased": "已離世",
      "created": "建立時間",
      "lastModified": "最後修改",
      "passportOnFile": "護照已存檔",
      "organDonorStatus": "器官捐贈狀態"
    },
    "statusValues": {
      "active": "啟用",
      "inactive": "停用"
    },
    "deceasedSummary": "是（{{date}}）",
    "deceasedDateUnknown": "日期不詳",
    "legalGender": {
      "label": "法定性別",
      "values": {
        "male": "男",
        "female": "女",
        "other": "其他",
        "unknown": "未知"
      },
      "selectPlaceholder": "請選擇性別"
    },
    "sexAtBirth": {
      "label": "出生時性別",
      "values": {
        "female": "女",
        "male": "男",
        "other": "其他",
        "unknown": "未知"
      },
      "notRecorded": "未記錄"
    },
    "preferredContactMethod": {
      "label": "首選聯絡方式",
      "values": {
        "phone": "電話",
        "mobile": "手提電話",
        "email": "電郵",
        "sms": "短訊"
      },
      "notSpecified": "未指定"
    },
    "validation": {
      "fullNameRequired": "姓名為必填項",
      "dateOfBirthRequired": "出生日期為必填項",
      "countryRequired": "國家/地區為必填項",
      "primaryLanguageRequired": "主要語言為必填項",
      "invalidEmail": "電郵格式無效",
      "nationalIdValidationFailed": "證件號碼驗證失敗：{{error}}",
      "invalidBirthTime": "出生時間必須為 HH:MM 格式"
    },
    "organDonor": {
      "notRecorded": "未記錄",
      "registered": "已登記捐贈",
      "optedOut": "已選擇退出",
      "notRegistered": "未登記",
      "unknown": "不詳"
    }
  },
  "registration": {
    "title": "病人登記",
    "subtitle": "於系統中登記新病人",
    "submit": "登記病人",
    "submitting": "正在登記...",
    "checkingDuplicates": "正在檢查重複紀錄...",
    "registerNew": "登記新病人",
    "registeredSuccess": "病人登記成功",
    "registerError": "病人登記失敗",
    "validationNationalIdFailed": "證件號碼驗證失敗：{{error}}",
    "sections": {
      "basicInformation": "基本資料",
      "identification": "身份證明",
      "contactInformation": "聯絡資料",
      "address": "地址",
      "languageAndCommunication": "語言及溝通",
      "additionalInformation": "其他資料"
    },
    "fields": {
      "facility": "登記機構"
    },
    "placeholders": {
      "fullName": "例如：Tan Wei Ming 或 李小明",
      "alternativeName": "如適用，請填寫羅馬拼音",
      "preferredName": "病人慣用的稱呼",
      "nationalIdNumberDefault": "請輸入證件號碼",
      "primaryPhone": "+852 9123 4567",
      "mobilePhone": "+852 8123 4567",
      "email": "patient@example.com",
      "facility": "請選擇機構"
    },
    "helperText": {
      "fullName": "請按官方證件上的姓名填寫",
      "facility": "為此病人辦理登記的機構。該機構的員工將可查閱此病歷。"
    },
    "flags": {
      "vipPatient": "VIP 病人",
      "medicalTourist": "醫療旅客"
    },
    "duplicate": {
      "title": "發現可能重複的病人",
      "body": "以下既有病人與閣下所輸入的資料相符：",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "證件號",
      "matchSummary": "匹配度：{{score}}%（{{reasons}}）",
      "useExisting": "使用既有紀錄",
      "createNew": "這是一位新病人",
      "restricted": {
        "title_one": "有 {{count}} 宗您無權查閱的可能相符記錄",
        "title_other": "有 {{count}} 宗您無權查閱的可能相符記錄",
        "body": "此病人可能在其他機構已有病歷。建立新病歷前請聯絡病歷管理部門——由於該記錄不在您的權限範圍內，詳細資料不予顯示。"
      },
      "overrideReasonLabel": "仍要登記的理由",
      "overrideReasonPlaceholder": "例如：已與病人確認並非同一人",
      "overrideReasonHelp": "此理由將記錄於您的帳戶。為同一人重複建檔會導致病歷分散。",
      "registerAnyway": "仍要登記"
    }
  },
  "search": {
    "title": "病人搜尋",
    "subtitle": "搜尋及管理病人紀錄",
    "placeholder": "按病人姓名、MRN 或證件號搜尋...",
    "advancedFilters": "進階篩選",
    "filters": {
      "mrnPlaceholder": "例如：P0000000001",
      "fullNamePlaceholder": "病人姓名",
      "phonePlaceholder": "電話號碼",
      "emailPlaceholder": "電郵地址"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "姓名",
      "dateOfBirth": "出生日期",
      "phone": "電話",
      "email": "電郵",
      "country": "國家/地區",
      "status": "狀態",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "全部",
      "vipOnly": "只顯示 VIP",
      "nonVipOnly": "只顯示非 VIP"
    },
    "statusFilter": {
      "all": "全部",
      "active": "啟用",
      "inactive": "停用"
    },
    "countryFilter": {
      "all": "所有國家/地區"
    },
    "clearFilters": "清除篩選",
    "dateOfBirthAria": "出生日期篩選",
    "columns": {
      "mrn": "MRN",
      "fullName": "姓名",
      "dob": "DOB",
      "gender": "性別",
      "phone": "電話",
      "country": "國家/地區",
      "status": "狀態"
    },
    "results": {
      "searching": "正在搜尋病人...",
      "loadError": "載入病人失敗，請重試。",
      "retry": "重試",
      "empty": "未找到病人，請調整搜尋條件。",
      "showing": "顯示第 {{from}} – {{to}} 項，共 {{total}} 位病人"
    }
  },
  "myPatients": {
    "title": "我的病人",
    "subtitle": "我負責的在院病人",
    "searchPlaceholder": "按姓名或MRN篩選...",
    "columns": {
      "mrn": "MRN",
      "patient": "姓名",
      "dob": "DOB",
      "sex": "性別",
      "class": "類別",
      "relationship": "關係",
      "admitted": "入院時間"
    },
    "kind": {
      "attending": "主診",
      "careTeam": "醫療團隊",
      "referral": "轉介",
      "coverage": "覆蓋"
    },
    "restrictedBadge": "受限",
    "empty": {
      "title": "您的病人面板是空的",
      "body": "您主管、代管或獲轉介的病人將顯示在這裡。",
      "censusAction": "開啟床位概況"
    },
    "results": {
      "searching": "正在載入您的病人...",
      "loadError": "載入您的病人失敗，請重試。",
      "retry": "重試",
      "showing": "顯示第 {{from}} – {{to}} 項，共 {{total}} 位病人"
    }
  },
  "encounters": {
    "title": "求診紀錄",
    "create": "新增求診",
    "filters": "篩選",
    "filterLabels": {
      "status": "狀態",
      "class": "類別",
      "fromDate": "起始日期",
      "toDate": "截止日期"
    },
    "filterPlaceholders": {
      "allStatuses": "所有狀態",
      "allClasses": "所有類別"
    },
    "clearFilters": "清除篩選",
    "fromDateAria": "起始日期",
    "toDateAria": "截止日期",
    "columns": {
      "encounterNumber": "求診編號",
      "class": "類別",
      "status": "狀態",
      "admitDate": "入院日期",
      "dischargeDate": "出院日期",
      "location": "科室位置",
      "chiefComplaint": "主訴"
    },
    "locationLabel": "位置 #{{id}}",
    "loading": "正在載入求診紀錄...",
    "loadError": "載入求診紀錄失敗。",
    "empty": "此病人暫無求診紀錄。",
    "showing": "顯示第 {{from}} – {{to}} 項，共 {{total}} 項"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "證件類型",
      "none": "無",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "泰國國民身份證"
      },
      "country": {
        "nric": "新加坡",
        "hkid": "香港",
        "myKad": "馬來西亞",
        "aadhaar": "印度",
        "ktp": "印尼",
        "myNumber": "日本",
        "thaiNationalId": "泰國"
      },
      "placeholderByType": {
        "nric": "例如：S1234567D",
        "myKad": "例如：850101-14-5678",
        "hkid": "例如：A123456(3)",
        "aadhaar": "例如：2341 2341 2346",
        "thaiNationalId": "例如：1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "此證件號碼的核對字元不符。請核對病人身份證明文件上的號碼。",
      "unavailable": "未能核對此證件號碼。請核對病人身份證明文件上的號碼。",
      "acknowledge": "我已核對身份證明文件上的號碼",
      "acknowledgeRequired": "儲存前請核對身份證明文件上的證件號碼並確認。"
    }
  },
  "country": {
    "values": {
      "sg": "新加坡",
      "my": "馬來西亞",
      "th": "泰國",
      "id": "印尼",
      "ph": "菲律賓",
      "vn": "越南",
      "hk": "香港",
      "tw": "台灣",
      "jp": "日本",
      "kr": "韓國",
      "cn": "中國內地",
      "in": "印度",
      "au": "澳洲",
      "nz": "紐西蘭"
    }
  },
  "language": {
    "values": {
      "en": "英文",
      "zh": "中文（普通話）",
      "ms": "馬來語",
      "ta": "泰米爾語",
      "th": "泰語",
      "id": "印尼語",
      "vi": "越南語",
      "ja": "日語",
      "ko": "韓語",
      "hi": "印地語"
    }
  },
  "contact": {
    "addTitle": "新增聯絡人",
    "editTitle": "編輯聯絡人",
    "name": "姓名",
    "relationship": {
      "label": "關係",
      "selectPlaceholder": "請選擇...",
      "values": {
        "spouse": "配偶",
        "parent": "父母",
        "child": "子女",
        "sibling": "兄弟姊妹",
        "guardian": "監護人",
        "friend": "朋友",
        "other": "其他"
      }
    },
    "phone": "電話",
    "email": "電郵",
    "emergencyContact": "緊急聯絡人",
    "validation": {
      "nameRequired": "聯絡人姓名為必填",
      "relationshipRequired": "關係為必填",
      "phoneRequired": "電話號碼為必填",
      "invalidEmail": "電郵格式無效"
    },
    "savedSuccess": "聯絡人新增成功",
    "saveError": "新增聯絡人失敗"
  },
  "immunization": {
    "addTitle": "新增疫苗接種紀錄",
    "vaccineName": "疫苗名稱",
    "vaccineNamePlaceholder": "例如:流感、新冠 (Pfizer)、乙型肝炎",
    "vaccineCode": "疫苗代碼 (CVX)",
    "vaccineCodePlaceholder": "例如:141",
    "administeredDate": "接種日期",
    "lotNumber": "批號",
    "lotNumberPlaceholder": "例如:AB1234",
    "site": {
      "label": "部位",
      "selectPlaceholder": "請選擇部位",
      "values": {
        "leftDeltoid": "左三角肌",
        "rightDeltoid": "右三角肌",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "leftGluteal": "左臀部",
        "rightGluteal": "右臀部",
        "other": "其他"
      }
    },
    "route": {
      "label": "途徑",
      "selectPlaceholder": "請選擇途徑",
      "values": {
        "intramuscular": "肌肉注射 (IM)",
        "subcutaneous": "皮下注射 (SC)",
        "intradermal": "皮內注射 (ID)",
        "oral": "口服",
        "intranasal": "鼻噴"
      }
    },
    "doseAmount": "劑量",
    "doseAmountPlaceholder": "例如:0.5 mL",
    "administeredBy": "施種人員",
    "administeredByPlaceholder": "醫護人員姓名或員工編號",
    "nextDueDate": "下次接種日期",
    "notes": "備註",
    "notesPlaceholder": "其他備註...",
    "validation": {
      "vaccineNameRequired": "疫苗名稱為必填",
      "administeredDateRequired": "接種日期為必填"
    },
    "savedSuccess": "疫苗接種紀錄已新增",
    "saveError": "新增疫苗接種紀錄失敗"
  },
  "insurance": {
    "addTitle": "新增保險計劃",
    "submitLabel": "新增保險",
    "payerName": "保險公司名稱",
    "payerNamePlaceholder": "例如:AIA 新加坡",
    "payerId": "保險公司編號",
    "payerIdPlaceholder": "保險公司識別碼",
    "planName": "計劃名稱",
    "planNamePlaceholder": "例如:HealthShield Gold Max",
    "planType": {
      "label": "計劃類型",
      "selectPlaceholder": "請選擇類型",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "政府",
        "private": "私人",
        "corporate": "團體",
        "other": "其他"
      }
    },
    "memberId": "會員編號",
    "memberIdPlaceholder": "會員編號",
    "policyNumber": "保單號碼",
    "policyNumberPlaceholder": "輸入保單號碼",
    "groupNumber": "團體編號",
    "groupNumberPlaceholder": "團體編號",
    "subscriberName": "投保人姓名",
    "subscriberNamePlaceholder": "如與病人不同請填寫",
    "subscriberRelationship": {
      "label": "與投保人關係",
      "values": {
        "self": "本人",
        "spouse": "配偶",
        "child": "子女",
        "parent": "父母",
        "other": "其他"
      }
    },
    "priority": {
      "label": "優先順序",
      "values": {
        "primary": "主要",
        "secondary": "次要",
        "tertiary": "第三"
      }
    },
    "effectiveDate": "生效日期",
    "terminationDate": "終止日期",
    "copayAmount": "自付金額 ($)",
    "coinsurancePercent": "共付比例 (%)",
    "deductibleAmount": "自負額 ($)",
    "outOfPocketMax": "自付上限 ($)",
    "preAuthRequired": "需事先授權",
    "notes": "備註",
    "notesPlaceholder": "其他備註...",
    "validation": {
      "payerNameRequired": "保險公司名稱為必填",
      "planNameRequired": "計劃名稱為必填",
      "memberIdRequired": "會員編號為必填",
      "effectiveDateRequired": "生效日期為必填"
    },
    "savedSuccess": "保險計劃已新增",
    "saveError": "新增保險計劃失敗"
  },
  "problem": {
    "addTitle": "新增問題",
    "problemName": "問題名稱",
    "problemNamePlaceholder": "例如:二型糖尿病",
    "icdCode": "ICD-10 編碼",
    "icdSearchPlaceholder": "搜尋 ICD-10 編碼或描述...",
    "onsetDate": "發病日期",
    "severity": {
      "label": "嚴重程度",
      "values": {
        "mild": "輕度",
        "moderate": "中度",
        "severe": "嚴重"
      }
    },
    "notes": "備註",
    "notesPlaceholder": "其他臨床備註...",
    "validation": {
      "problemNameRequired": "問題名稱為必填"
    },
    "savedSuccess": "問題已加入問題清單",
    "saveError": "新增問題失敗"
  },
  "accounts": {
    "pageTitle": "病人帳戶",
    "backToDashboard": "主控台",
    "searchPatientLabel": "搜尋病人",
    "searchPlaceholder": "以姓名或 MRN 搜尋...",
    "searching": "搜尋中...",
    "noPatientsFound": "找不到病人",
    "loadingAccount": "正在載入帳戶...",
    "mrnLabel": "MRN",
    "generateStatement": "產生結算單",
    "statementComingSoon": "結算單產生功能即將推出",
    "paymentPlan": "付款計劃",
    "paymentPlanComingSoon": "付款計劃設定即將推出",
    "totalCharges": "總費用",
    "totalPayments": "總付款",
    "adjustments": "調整",
    "outstandingBalance": "未付餘額",
    "transactionHistory": "交易紀錄",
    "columns": {
      "date": "日期",
      "type": "類型",
      "description": "說明",
      "amount": "金額",
      "balance": "餘額"
    },
    "transactionType": {
      "label": "類型",
      "values": {
        "charge": "收費",
        "payment": "付款",
        "adjustment": "調整"
      }
    },
    "loadingTransactions": "正在載入交易...",
    "noTransactionsFound": "找不到交易紀錄",
    "emptyState": "搜尋病人以檢視其帳戶"
  },
  "proxies": {
    "title": "授權代理人",
    "description": "獲授權存取此病人入門網站資料的照顧者、監護人及法定代理人。已撤銷紀錄會保留作審計用途。",
    "addProxy": "新增代理人",
    "newRelationshipHeading": "新增代理關係",
    "proxyUserId": "代理使用者 ID",
    "proxyUserIdPlaceholder": "使用者 ID(來自 管理 → 使用者)",
    "proxyUserIdHelper": "請在 管理 → 使用者 中查詢。使用者揀選器將於後續版本提供。",
    "relationship": {
      "label": "關係",
      "values": {
        "parent": "父母",
        "legalGuardian": "法定監護人",
        "spousePartner": "配偶 / 伴侶",
        "adultChild": "成年子女",
        "powerOfAttorney": "授權書代理人",
        "healthcareAgent": "醫療代理人"
      }
    },
    "accessLevel": {
      "label": "存取權限",
      "values": {
        "full": "完整",
        "limited": "受限",
        "emergency": "緊急"
      },
      "descriptions": {
        "full": "全部入門網站資料 — 預約、檢驗結果、訊息、表格。",
        "limited": "僅預約與訊息(青少年常用)。",
        "emergency": "病人失去能力時醫療代理人享有的緊急存取權限。"
      }
    },
    "startDate": "開始日期",
    "endDate": "結束日期",
    "startDateAria": "生效開始日期",
    "endDateAria": "生效結束日期",
    "grantAccess": "授予代理存取權",
    "userIdRequired": "需要代理使用者 ID",
    "createdSuccess": "代理關係已建立",
    "duplicateError": "此人已是相同關係的代理人",
    "invalidDataError": "代理資料無效",
    "createError": "建立代理失敗",
    "revokedSuccess": "代理存取權已撤銷",
    "revokeError": "撤銷代理失敗",
    "emptyState": "尚未設定代理人。請使用上方按鈕授予照顧者、監護人或醫療代理人存取權。",
    "sections": {
      "active": "有效 ({{count}})",
      "plannedInactive": "計劃中 / 未生效 ({{count}})",
      "revoked": "已撤銷 ({{count}})"
    },
    "userIdFallback": "使用者 #{{id}}",
    "noEndDate": "(沒有結束日期)",
    "revokedOn": "已撤銷 {{date}}",
    "revokeTitle": "撤銷代理存取權",
    "confirmRevokeTitle": "撤銷代理存取權?",
    "confirmRevokeBody": "{{name}} 將會立即失去存取此病人入門網站資料的權限。紀錄會保留於審計日誌中。",
    "confirmRevokeLabel": "撤銷存取"
  },
  "merge": {
    "title": "病人合併",
    "description": "合併重複的病人紀錄。來源病人將被停用,所有臨床資料將移至目標(保留)病人。",
    "sourceLabel": "來源病人(將被停用)",
    "targetLabel": "目標病人(保留紀錄)",
    "clearSelection": "清除選擇",
    "searchPlaceholder": "以姓名、MRN 或電話搜尋...",
    "fields": {
      "mrn": "MRN",
      "dob": "出生日期",
      "gender": "性別",
      "country": "國家",
      "phone": "電話",
      "email": "電郵"
    },
    "counts": {
      "encounters": "就診紀錄:{{count}}",
      "allergies": "過敏史:{{count}}",
      "problems": "問題:{{count}}"
    },
    "samePatientWarning": "來源與目標必須為不同病人。",
    "comparisonTitle": "人口學資料比較",
    "comparisonSubtitle": "差異會以琥珀色標示。",
    "columns": {
      "field": "欄位",
      "source": "來源 ({{mrn}})",
      "target": "目標 ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "全名",
      "mrn": "MRN",
      "dateOfBirth": "出生日期",
      "gender": "性別",
      "phone": "電話",
      "email": "電郵",
      "country": "國家",
      "nationalId": "身分證號碼"
    },
    "reasonLabel": "合併原因",
    "reasonPlaceholder": "合併此等紀錄的原因(必填)",
    "notesLabel": "備註(選填)",
    "notesPlaceholder": "關於此次合併的其他備註",
    "mergeButton": "合併病人",
    "mergeSuccess": "病人合併成功",
    "mergeError": "合併病人失敗",
    "successHeading": "合併已成功完成。",
    "successBodyPrefix": "病人 {{mrn}} 已被停用。所有臨床資料已移至 ",
    "successBodySuffix": "。",
    "confirmTitle": "確認合併病人",
    "confirmBodyPrefix": "此操作",
    "confirmBodyEmphasis": "無法復原",
    "confirmBodySuffix": "。病人 {{sourceMrn}} ({{sourceName}}) 將被停用,所有臨床資料將移至病人 {{targetMrn}} ({{targetName}})。",
    "confirmButton": "確認合併病人",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "無法載入病人紀錄。"
  },
  "allergy": {
    "addTitle": "新增過敏記錄",
    "editTitle": "編輯過敏記錄",
    "allergen": "過敏原",
    "allergenPlaceholder": "例如：盤尼西林、花生",
    "type": "類型",
    "typeOptions": {
      "drug": "藥物",
      "food": "食物",
      "environmental": "環境"
    },
    "severityLabel": "嚴重程度",
    "severity": {
      "mild": "輕度",
      "moderate": "中度",
      "severe": "嚴重",
      "lifeThreatening": "危及生命"
    },
    "reaction": "反應",
    "reactionPlaceholder": "例如：蕁麻疹、過敏性休克、作嘔",
    "reactionOptions": {
      "rash": "皮疹",
      "hives": "蕁麻疹",
      "anaphylaxis": "過敏性休克",
      "swelling": "腫脹",
      "itching": "痕癢",
      "other": "其他"
    },
    "onsetDate": "出現日期",
    "notes": "備註",
    "notesPlaceholder": "其他備註...",
    "verifiedBy": "核實人",
    "noKnownAllergies": "無已知過敏",
    "savedSuccess": "成功新增過敏記錄",
    "saveError": "新增過敏記錄失敗",
    "deletedSuccess": "已移除過敏記錄"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "Braden 量表（壓瘡風險）",
      "footer": "總分範圍：6-23。分數越低，發生壓力性損傷嘅風險越高。",
      "scoreFormat": "得分：{{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "極高風險",
        "high": "高風險",
        "moderate": "中度風險",
        "mild": "輕度風險",
        "none": "無風險"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. 感覺",
          "options": {
            "1": "{{n}} - 完全受限",
            "2": "{{n}} - 非常受限",
            "3": "{{n}} - 輕度受限",
            "4": "{{n}} - 未受損"
          }
        },
        "moisture": {
          "label": "{{n}}. 潮濕",
          "options": {
            "1": "{{n}} - 持續潮濕",
            "2": "{{n}} - 非常潮濕",
            "3": "{{n}} - 偶爾潮濕",
            "4": "{{n}} - 極少潮濕"
          }
        },
        "activity": {
          "label": "{{n}}. 活動",
          "options": {
            "1": "{{n}} - 臥床",
            "2": "{{n}} - 限於椅上",
            "3": "{{n}} - 偶爾行走",
            "4": "{{n}} - 經常行走"
          }
        },
        "mobility": {
          "label": "{{n}}. 移動能力",
          "options": {
            "1": "{{n}} - 完全不能移動",
            "2": "{{n}} - 非常受限",
            "3": "{{n}} - 輕度受限",
            "4": "{{n}} - 無限制"
          }
        },
        "nutrition": {
          "label": "{{n}}. 營養",
          "options": {
            "1": "{{n}} - 非常差",
            "2": "{{n}} - 可能不足",
            "3": "{{n}} - 充足",
            "4": "{{n}} - 優良"
          }
        },
        "frictionShear": {
          "label": "{{n}}. 摩擦與剪力",
          "options": {
            "1": "{{n}} - 有問題",
            "2": "{{n}} - 可能有問題",
            "3": "{{n}} - 無明顯問題"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "莫爾斯跌倒量表",
      "scoreFormat": "評分：{{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. 跌倒史",
          "options": {
            "0": "無（{{score}}）",
            "25": "有（{{score}}）"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. 次要診斷",
          "options": {
            "0": "無（{{score}}）",
            "15": "有（{{score}}）"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. 行走輔助",
          "options": {
            "0": "無／臥床休息／護士協助（{{score}}）",
            "15": "拐杖／手杖／助行器（{{score}}）",
            "30": "依靠傢俬支撐（{{score}}）"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. 靜脈輸液／肝素鎖",
          "options": {
            "0": "無（{{score}}）",
            "20": "有（{{score}}）"
          }
        },
        "gait": {
          "label": "{{n}}. 步態",
          "options": {
            "0": "正常／臥床休息／輪椅（{{score}}）",
            "10": "虛弱（{{score}}）",
            "20": "受損（{{score}}）"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. 精神狀態",
          "options": {
            "0": "能正確認識自身能力（{{score}}）",
            "15": "高估自身能力／忘記自身限制（{{score}}）"
          }
        }
      },
      "interventions": {
        "high": "高風險介入：實施標準跌倒預防措施。為病人佩戴跌倒風險腕帶。在床邊張貼跌倒風險標識。對病人及家屬進行教育。保持床位處於最低位置並鎖定剎車。確保呼叫鈴在伸手可及範圍內。穿防滑鞋。安排如廁時間表。必要時考慮1對1看護。",
        "moderate": "中風險介入：實施標準跌倒預防措施。為病人佩戴跌倒風險腕帶。對病人及家屬進行教育。保持床位處於最低位置並鎖定剎車。確保呼叫鈴在伸手可及範圍內。穿防滑鞋。",
        "low": "低風險介入：提供良好的基礎護理。教育病人安全活動。介紹環境和呼叫鈴的使用方法。"
      }
    }
  },
  "banner": {
    "label": "病人資料",
    "vip": "VIP",
    "vipTitle": "VIP 病人",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "歲",
    "sex": "性別",
    "codeStatusAria": "急救代碼：{{status}}",
    "isolationAria": "隔離：{{status}}",
    "isolation": {
      "contact": "接觸隔離",
      "droplet": "飛沫隔離",
      "airborne": "空氣傳播隔離",
      "none": "無"
    },
    "fallRiskAria": "跌倒風險：{{level}}",
    "fallRisk": {
      "label": "跌倒風險",
      "low": "低",
      "moderate": "中",
      "high": "高"
    },
    "pressureInjuryRisk": "壓瘡風險",
    "pressureInjuryRiskAria": "壓瘡風險：{{level}}",
    "interpreter": "傳譯員",
    "interpreterRequired": "需要傳譯員 — {{language}}",
    "languageNotSpecified": "未指明語言",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "過敏",
    "moreAllergies_one": "+另有 {{count}} 項",
    "moreAllergies_other": "+另有 {{count}} 項",
    "nkda": "NKDA",
    "allergiesUnknown": "過敏史未知——載入失敗"
  },
  "chartFrame": {
    "navAriaLabel": "病人病歷導覽",
    "tabs": {
      "summary": "概覽",
      "encounters": "求診紀錄",
      "orders": "醫囑",
      "results": "化驗結果",
      "medications": "藥物",
      "notes": "病歷記錄",
      "problems": "問題清單",
      "allergies": "過敏史",
      "immunizations": "防疫注射",
      "intakeOutput": "出入量",
      "carePlans": "護理計劃",
      "referrals": "轉介",
      "familyHistory": "家族史",
      "socialHistory": "社會史",
      "surgicalHistory": "手術史",
      "advanceDirectives": "預設醫療指示",
      "insurance": "保險",
      "contacts": "聯絡人",
      "proxies": "代理人",
      "identifiers": "識別號",
      "addresses": "地址",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "醫材",
      "ccdaImports": "C-CDA 匯入"
    },
    "groups": {
      "clinical": "臨床",
      "history": "病史",
      "admin": "行政"
    },
    "breakGlass": {
      "auditBanner": "緊急存取 — 所有活動均受審計。存取將於 15 分鐘後到期。",
      "dialogTitle": "受限病人紀錄",
      "dialogSubtitle": "需要緊急存取授權",
      "dialogBody": "此病人紀錄受限。閣下須提供存取理由。所有緊急存取均會被記錄及審計。",
      "justificationLabel": "存取理由",
      "justificationPlaceholder": "請輸入存取此受限紀錄的臨床理由...",
      "justificationRequired": "緊急存取須提供理由。",
      "requestError": "緊急存取申請失敗。請重試或聯絡系統管理員。",
      "submitButton": "存取紀錄",
      "submitting": "申請中...",
      "passwordLabel": "確認您的密碼",
      "passwordPlaceholder": "請再次輸入您的密碼",
      "passwordRequired": "緊急存取需要您的密碼。",
      "passwordIncorrect": "密碼不正確，請重試。",
      "passwordHelp": "確認在此工作站操作的是您本人。",
      "totpLabel": "验證碼",
      "totpPlaceholder": "6位數验證碼",
      "totpRequired": "緊急存取需要您的验證器验證碼。",
      "totpIncorrect": "验證碼不正確，請重試。",
      "totpHelp": "確認在此工作站操作的是您本人。",
      "totpEnrollHint": "尚未綁定验證器——請先在「我的個人檔案」中綁定，以便使用緊急存取。"
    },
    "invalidId": {
      "title": "無效的病人編號",
      "body": "所提供的病人編號無效。",
      "action": "搜尋病人"
    },
    "notFound": {
      "title": "找不到病人",
      "body": "無法載入病人資料。此病人可能不存在或閣下沒有存取權限。",
      "action": "搜尋病人"
    },
    "loadError": {
      "title": "病人圖表載入失敗",
      "body": "圖表無法載入。請重試。",
      "action": "重試"
    }
  },
  "address": {
    "title": "地址",
    "addAddress": "新增地址",
    "newTitle": "新增地址",
    "editTitle": "編輯地址",
    "loading": "正在載入地址...",
    "loadError": "載入地址資料失敗。",
    "empty": "尚無地址紀錄。",
    "addressType": {
      "label": "類別",
      "values": {
        "home": "住址",
        "work": "工作地點",
        "temporary": "臨時",
        "billing": "賬單"
      }
    },
    "fields": {
      "addressLine1": "地址第一行",
      "addressLine2": "地址第二行",
      "addressLine3": "地址第三行",
      "district": "區",
      "city": "城市",
      "stateProvince": "省/州",
      "postalCode": "郵政編號",
      "country": "國家/地區"
    },
    "placeholders": {
      "addressLine1": "街道地址",
      "addressLine2": "單位、樓層",
      "addressLine3": "大廈、屋苑",
      "district": "區/分區",
      "postalCode": "例如:N/A",
      "country": "例如:HK"
    },
    "primaryBadge": "主要",
    "setPrimary": "設為主要地址",
    "primaryHelper": "(其他地址將被取消主要標記)",
    "fromLabel": "由:{{date}}",
    "toLabel": "至:{{date}}",
    "save": "儲存",
    "update": "更新",
    "cancel": "取消",
    "editTooltip": "編輯地址",
    "removeTooltip": "刪除地址",
    "addedSuccess": "已新增地址",
    "addError": "新增地址失敗",
    "updatedSuccess": "地址已更新",
    "updateError": "更新地址失敗",
    "removedSuccess": "地址已刪除",
    "removeError": "刪除地址失敗",
    "requiredError": "地址第一行及國家為必填項",
    "confirmRemoveTitle": "刪除地址",
    "confirmRemoveMessage": "確定要刪除這個{{type}}地址嗎?",
    "confirmRemoveLabel": "刪除"
  },
  "allergies": {
    "pageTitle": "過敏紀錄",
    "addAllergy": "新增過敏",
    "loading": "正在載入過敏紀錄...",
    "loadError": "載入過敏資料失敗。",
    "nka": {
      "title": "無已知過敏 (NKA)",
      "body": "本病人沒有過敏紀錄。"
    },
    "sections": {
      "active": "現存過敏 ({{count}})",
      "inactive": "已停用過敏 ({{count}})"
    },
    "fields": {
      "reaction": "反應",
      "severity": "嚴重程度",
      "onset": "出現時間",
      "recorded": "紀錄時間"
    },
    "inactiveSummary": "反應:{{reaction}} | 嚴重程度:{{severity}}",
    "deactivate": "停用",
    "deactivateTooltip": "停用過敏紀錄",
    "deleteTooltip": "刪除過敏紀錄",
    "deactivatedSuccess": "過敏紀錄已停用",
    "deactivateError": "停用過敏紀錄失敗",
    "removedSuccess": "過敏紀錄已刪除",
    "removeError": "刪除過敏紀錄失敗",
    "confirmDeactivateTitle": "確認停用",
    "confirmDeactivateMessage": "確定要停用「{{name}}」嗎?",
    "confirmDeleteTitle": "確認刪除",
    "confirmDeleteMessage": "確定要永久刪除「{{name}}」嗎?",
    "confirmLabel": "確認"
  },
  "problems": {
    "pageTitle": "問題清單",
    "addProblem": "新增問題",
    "loading": "正在載入問題清單...",
    "loadError": "載入問題清單失敗。",
    "tabs": {
      "active": "現存 ({{count}})",
      "resolvedInactive": "已解決/已停用 ({{count}})"
    },
    "sortByLabel": "排序:",
    "sortBy": {
      "onsetDate": "出現日期",
      "severity": "嚴重程度"
    },
    "status": {
      "label": "狀態",
      "values": {
        "active": "現存",
        "resolved": "已解決",
        "inactive": "已停用"
      }
    },
    "empty": {
      "active": "尚無現存問題紀錄。",
      "resolved": "尚無已解決或已停用問題。"
    },
    "fields": {
      "onset": "出現",
      "resolved": "解決"
    },
    "resolveButton": "標記為已解決",
    "reactivateButton": "重新啟用",
    "resolveTooltip": "標記為已解決",
    "reactivateTooltip": "重新啟用",
    "statusUpdatedSuccess": "問題狀態已更新",
    "statusUpdateError": "更新問題狀態失敗"
  },
  "immunizations": {
    "pageTitle": "疫苗接種",
    "addImmunization": "新增疫苗接種",
    "loading": "正在載入疫苗接種紀錄...",
    "loadError": "載入疫苗接種紀錄失敗。",
    "empty": "未找到疫苗接種紀錄。",
    "dueOverdue": "應接種/逾期疫苗 ({{count}})",
    "upcoming": "即將接種 ({{count}})",
    "dueLabel": "應接種:{{date}}",
    "fromDateLabel": "起始日期",
    "toDateLabel": "結束日期",
    "fromDateAria": "疫苗接種起始日期",
    "toDateAria": "疫苗接種結束日期",
    "clearFilters": "清除",
    "cvxLabel": "CVX:{{code}}",
    "columns": {
      "vaccine": "疫苗",
      "date": "接種日期",
      "lotNumber": "批號",
      "site": "部位",
      "administeredBy": "接種者",
      "nextDue": "下次接種",
      "status": "狀態"
    },
    "dueStatus": {
      "label": "狀態",
      "values": {
        "overdue": "逾期",
        "dueToday": "今日到期",
        "upcoming": "即將到期"
      }
    }
  },
  "contacts": {
    "pageTitle": "聯絡人",
    "addContact": "新增聯絡人",
    "loading": "正在載入聯絡人...",
    "loadError": "載入聯絡人資料失敗。",
    "empty": "尚無聯絡人紀錄。",
    "emergencyBadge": "緊急",
    "sections": {
      "emergency": "緊急聯絡人 ({{count}})",
      "other": "其他聯絡人 ({{count}})"
    },
    "editTooltip": "編輯聯絡人",
    "deleteTooltip": "刪除聯絡人",
    "deletedSuccess": "聯絡人已刪除",
    "deleteError": "刪除聯絡人失敗",
    "confirmDeleteTitle": "刪除聯絡人",
    "confirmDeleteMessage": "確定要刪除「{{name}}」嗎?",
    "confirmDeleteLabel": "刪除"
  },
  "insurances": {
    "pageTitle": "保險",
    "addInsurance": "新增保險",
    "loading": "正在載入保險資料...",
    "loadError": "載入保險資料失敗。",
    "empty": {
      "title": "無保險計劃",
      "body": "本病人尚無保險計劃紀錄。"
    },
    "sections": {
      "active": "有效計劃 ({{count}})",
      "inactive": "已失效計劃 ({{count}})"
    },
    "status": {
      "label": "狀態",
      "values": {
        "active": "有效",
        "inactive": "失效",
        "pendingVerification": "待核實"
      }
    },
    "fields": {
      "memberId": "會員號",
      "groupNumber": "團體號",
      "effectiveDate": "生效日期",
      "terminationDate": "終止日期",
      "copay": "自付",
      "coinsurance": "共保",
      "deductible": "墊底費",
      "subscriber": "投保人"
    },
    "preAuthBadge": "需事前批准",
    "lastVerifiedLabel": "最近核實:{{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "核實",
    "verifyTooltip": "核實資格",
    "editButton": "編輯",
    "verifySuccess": "已啟動資格核實",
    "verifyError": "資格核實失敗"
  },
  "identifiersTab": {
    "pageTitle": "識別號",
    "addIdentifier": "新增識別號",
    "loading": "正在載入識別號...",
    "loadError": "載入識別號資料失敗。",
    "empty": "尚無識別號紀錄。",
    "newTitle": "新增識別號",
    "type": {
      "label": "類型",
      "selectPlaceholder": "請選擇類型...",
      "values": {
        "externalMrn": "外部 MRN",
        "insuranceId": "保險編號",
        "studyId": "研究編號",
        "healthCard": "醫療卡",
        "nationalRegistry": "身份登記號",
        "passport": "護照",
        "driverLicense": "駕駛執照",
        "other": "其他"
      }
    },
    "fields": {
      "value": "號碼",
      "assigningAuthority": "發證機關",
      "effectiveDate": "生效日期",
      "expiryDate": "到期日期"
    },
    "placeholders": {
      "value": "例如:A123456(3)",
      "assigningAuthority": "例如:香港入境處"
    },
    "status": {
      "label": "狀態",
      "values": {
        "active": "有效",
        "inactive": "失效"
      }
    },
    "columns": {
      "type": "類型",
      "value": "號碼",
      "assigningAuthority": "發證機關",
      "effectiveDate": "生效日期",
      "expiryDate": "到期日期",
      "status": "狀態",
      "actions": "操作"
    },
    "save": "儲存",
    "cancel": "取消",
    "removeTooltip": "刪除識別號",
    "addedSuccess": "識別號已新增",
    "addError": "新增識別號失敗",
    "removedSuccess": "識別號已刪除",
    "removeError": "刪除識別號失敗",
    "requiredError": "類型及號碼為必填項",
    "confirmRemoveTitle": "刪除識別號",
    "confirmRemoveMessage": "確定要刪除「{{type}}:{{value}}」嗎?",
    "confirmRemoveLabel": "刪除"
  },
  "pages": {
    "advanceDirectives": {
      "title": "預設醫療指示",
      "addButton": "新增指示",
      "emptyState": "此病人並無記錄任何預設醫療指示。",
      "loading": "正在載入預設醫療指示...",
      "loadError": "載入預設醫療指示失敗。",
      "documentLink": "檢視文件",
      "effectivePrefix": "生效:",
      "reviewPrefix": "覆核:",
      "form": {
        "title": "新增預設醫療指示",
        "labels": {
          "directiveType": "指示類別",
          "status": "狀態",
          "effectiveDate": "生效日期",
          "notes": "備註",
          "optional": "選填"
        },
        "placeholders": {
          "notes": "有關此指示的補充備註..."
        },
        "selectTypePlaceholder": "請選擇類別...",
        "aria": {
          "effectiveDate": "生效日期"
        },
        "buttons": {
          "save": "儲存指示",
          "cancel": "取消"
        }
      },
      "directiveType": {
        "DNR": "不作心肺復甦法(DNR)",
        "living-will": "生前意願書",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "醫療代理人",
        "power-of-attorney": "持久授權書"
      },
      "directiveStatus": {
        "active": "有效",
        "inactive": "無效",
        "revoked": "已撤回",
        "pending": "待覆核"
      },
      "toast": {
        "added": "已新增預設醫療指示",
        "addFailed": "新增預設醫療指示失敗",
        "directiveTypeRequired": "指示類別為必填項"
      }
    },
    "familyHistory": {
      "title": "家族病史",
      "addButton": "新增項目",
      "emptyState": "此病人尚未記錄任何家族病史。",
      "loading": "正在載入家族病史...",
      "loadError": "載入家族病史失敗。",
      "onsetAge": "發病年齡:{{age}} 歲",
      "outcomePrefix": "結局:",
      "form": {
        "title": "新增家族病史項目",
        "labels": {
          "relationship": "親屬關係",
          "conditionName": "疾病名稱",
          "conditionCode": "疾病代碼",
          "onsetAge": "發病年齡",
          "outcome": "結局",
          "optional": "選填"
        },
        "placeholders": {
          "onsetAge": "年齡(歲)"
        },
        "selectRelationshipPlaceholder": "請選擇親屬關係...",
        "selectOutcomePlaceholder": "請選擇結局...",
        "buttons": {
          "save": "儲存項目",
          "cancel": "取消"
        }
      },
      "relationship": {
        "Mother": "母親",
        "Father": "父親",
        "Sibling": "兄弟姊妹",
        "Maternal Grandmother": "外婆",
        "Maternal Grandfather": "外公",
        "Paternal Grandmother": "嫲嫲",
        "Paternal Grandfather": "爺爺",
        "Child": "子女",
        "Aunt": "姑媽/姨媽",
        "Uncle": "伯父/叔父/舅父"
      },
      "outcome": {
        "alive": "在世",
        "deceased": "已故",
        "unknown": "不詳"
      },
      "toast": {
        "added": "已新增家族病史項目",
        "addFailed": "新增家族病史項目失敗",
        "relationshipAndConditionRequired": "親屬關係和疾病名稱為必填項"
      }
    },
    "socialHistory": {
      "title": "社會史",
      "editButton": "編輯",
      "loading": "正在載入社會史...",
      "loadError": "載入社會史失敗。",
      "labels": {
        "smokingStatus": "吸煙狀況",
        "alcoholUse": "飲酒",
        "substanceUse": "藥物使用",
        "housing": "居住情況",
        "employment": "就業狀況",
        "safetyScreening": "安全篩查",
        "notes": "備註"
      },
      "placeholders": {
        "notes": "附加備註..."
      },
      "buttons": {
        "save": "儲存變更",
        "cancel": "取消"
      },
      "toast": {
        "updated": "社會史已更新",
        "updateFailed": "社會史更新失敗"
      },
      "smokingStatus": {
        "never": "從不吸煙者",
        "former": "既往吸煙者",
        "currentDaily": "目前每日吸煙者",
        "currentOccasional": "目前偶爾吸煙者",
        "unknown": "不明"
      },
      "alcoholUse": {
        "None": "無",
        "Social/Occasional": "社交/偶爾",
        "Moderate": "中等",
        "Heavy": "大量",
        "In Recovery": "康復中",
        "Unknown": "不明"
      },
      "substanceUse": {
        "None": "無",
        "Current Use": "目前使用",
        "Former Use": "既往使用",
        "In Treatment": "治療中",
        "Unknown": "不明"
      },
      "housing": {
        "Stable": "穩定",
        "Unstable": "不穩定",
        "Homeless": "無家可歸",
        "Assisted Living": "輔助生活",
        "Nursing Facility": "護理機構",
        "Unknown": "不明"
      },
      "employment": {
        "Employed Full-Time": "全職就業",
        "Employed Part-Time": "兼職就業",
        "Self-Employed": "自僱",
        "Unemployed": "失業",
        "Retired": "退休",
        "Student": "學生",
        "Disabled": "殘障無法工作",
        "Unknown": "不明"
      },
      "safetyScreening": {
        "No Concerns": "無顧慮",
        "Concerns Identified": "已識別顧慮",
        "Declined to Answer": "拒絕回答",
        "Not Screened": "未篩查"
      }
    },
    "surgicalHistory": {
      "title": "手術史",
      "addButton": "加入手術",
      "emptyState": "此病人無手術史記錄。",
      "loading": "載入手術史中...",
      "loadError": "無法載入手術史。",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "日期：{{date}}",
      "surgeonLabel": "外科醫生：{{name}}",
      "anesthesiaLabel": "麻醉：{{type}}",
      "outcomePrefix": "結果：",
      "complicationsPrefix": "併發症：",
      "form": {
        "title": "新增手術史記錄",
        "labels": {
          "procedureName": "手術名稱",
          "procedureCode": "手術編號",
          "procedureCodeSuffix": "(CPT)",
          "date": "日期",
          "surgeonName": "外科醫生姓名",
          "anesthesiaType": "麻醉類型",
          "laterality": "側別",
          "outcome": "結果",
          "complications": "併發症"
        },
        "placeholders": {
          "surgeonName": "外科醫生姓名",
          "complications": "如有併發症..."
        },
        "selectPlaceholder": "請選擇...",
        "aria": {
          "procedureDate": "手術日期"
        },
        "buttons": {
          "save": "儲存記錄",
          "cancel": "取消"
        }
      },
      "anesthesiaType": {
        "general": "全身麻醉",
        "regional": "區域麻醉",
        "local": "局部麻醉",
        "spinal": "脊髓麻醉",
        "epidural": "硬膜外麻醉",
        "sedation": "鎮靜",
        "none": "無",
        "unknown": "不明"
      },
      "laterality": {
        "left": "左側",
        "right": "右側",
        "bilateral": "雙側"
      },
      "toast": {
        "added": "已加入手術史記錄",
        "addFailed": "加入手術史記錄失敗",
        "procedureNameRequired": "必須填寫手術名稱"
      }
    },
    "referralManagement": {
      "title": "轉介",
      "addButton": "新增轉介",
      "refresh": "重新整理",
      "loading": "正在載入轉介...",
      "errorState": "載入轉介失敗。",
      "emptyState": "此病人並無轉介記錄。",
      "emptyStateFiltered": "沒有符合所選狀態的轉介。",
      "ariaFilterStatus": "按狀態篩選轉介",
      "externalBadge": "外部",
      "filterStatus": {
        "allLabel": "所有狀態"
      },
      "table": {
        "type": "類型",
        "reason": "原因",
        "specialty": "專科",
        "priority": "優先次序",
        "status": "狀態",
        "requested": "申請日期",
        "target": "目標日期"
      },
      "form": {
        "title": "新增轉介",
        "labels": {
          "referralType": "轉介類別",
          "priority": "優先次序",
          "specialty": "專科",
          "reason": "原因",
          "targetDate": "目標日期",
          "clinicalNotes": "臨床備註",
          "optional": "選填"
        },
        "placeholders": {
          "reason": "轉介原因",
          "clinicalNotes": "補充臨床備註..."
        },
        "selectReferralTypePlaceholder": "請選擇類別...",
        "selectSpecialtyPlaceholder": "請選擇專科...",
        "buttons": {
          "create": "建立轉介",
          "cancel": "取消"
        }
      },
      "referralType": {
        "consultation": "會診",
        "transfer": "轉介照護",
        "second-opinion": "第二意見",
        "diagnostic": "診斷性",
        "therapeutic": "治療性"
      },
      "priority": {
        "routine": "常規",
        "urgent": "緊急",
        "stat": "STAT"
      },
      "status": {
        "draft": "草稿",
        "submitted": "已提交",
        "accepted": "已接受",
        "scheduled": "已編排",
        "completed": "已完成",
        "cancelled": "已取消"
      },
      "toasts": {
        "createSuccess": "已建立轉介",
        "createFailed": "建立轉介失敗",
        "validationFailed": "轉介類別與原因為必填項"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "有 {{count}} 組配對涉及您無權查閱的病人",
      "title_other": "有 {{count}} 組配對涉及您無權查閱的病人",
      "body": "您的某位病人可能與其他機構的病歷重複。由於判斷該配對需查閱您權限外的病人，故未列於清單——請聯絡病歷管理部門審核。"
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "匯出病歷",
    "exporting": "正在匯出…",
    "success": "病歷已匯出",
    "failed": "匯出失敗 — 未下載任何內容",
    "tooltip": "將該病人的完整病歷下載為可攜式檔案"
  },
  "device": {
    "addTitle": "記錄植入醫材",
    "editTitle": "記錄取出",
    "deviceName": "醫材名稱",
    "deviceNamePlaceholder": "例如：Evera MRI ICD、薥物洗脫支架",
    "deviceNameTooLong": "醫材名稱不得超過512個字元",
    "deviceType": "醫材類型",
    "deviceTypePlaceholder": "例如：節律器、支架、義肢",
    "udi": "UDI",
    "udiPlaceholder": "醫療器材唯一識別載體",
    "deviceCode": "醫材編碼",
    "deviceCodeSystem": "編碼系統",
    "deviceCodeSystemPlaceholder": "例如：GMDN、SNOMED CT",
    "manufacturer": "製造商",
    "modelNumber": "型號",
    "lotNumber": "批號",
    "serialNumber": "序號",
    "implantDate": "植入日期",
    "explantDate": "取出日期",
    "status": "狀態",
    "statusOptions": {
      "active": "使用中",
      "inactive": "已停用",
      "explanted": "已取出"
    },
    "mriSafety": "MRI安全性",
    "mriSafetyOptions": {
      "safe": "安全",
      "conditional": "有條件安全",
      "unsafe": "不安全",
      "unknown": "未知"
    },
    "notes": "備註",
    "notesPlaceholder": "其他備註...",
    "savedSuccess": "醫材記錄成功",
    "saveError": "記錄醫材失敗",
    "updatedSuccess": "取出記錄成功",
    "updateError": "記錄取出失敗",
    "explantRequiresDate": "已取出的醫材需要取出日期",
    "explantBeforeImplant": "取出日期不可早於植入日期"
  },
  "devices": {
    "pageTitle": "植入醫材",
    "addDevice": "記錄醫材",
    "loading": "正在載入醫材...",
    "loadError": "載入醫材資訊失敗。",
    "empty": {
      "title": "無植入醫材",
      "body": "此病人尚未記錄任何醫材。"
    },
    "sections": {
      "active": "使用中醫材 ({{count}})",
      "history": "已取出/已停用 ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "製造商",
      "implanted": "植入",
      "explanted": "取出",
      "mriSafety": "MRI安全性",
      "recorded": "記錄於"
    },
    "recordExplant": "記錄取出",
    "explantTooltip": "記錄取出此醫材",
    "removeTooltip": "刪除項目",
    "removedSuccess": "已刪除醫材項目",
    "removeError": "刪除醫材項目失敗",
    "confirmDeleteTitle": "確認刪除",
    "confirmDeleteMessage": "從清單刪除「{{name}}」？僅刪除誤錄項目——記錄自體內取出請使用「記錄取出」。",
    "confirmLabel": "確認"
  },
  "ccdaImports": {
    "title": "C-CDA 匯入",
    "subtitle": "待核對嘅接收文件。開啟匯入，逐條審核併入病歷。",
    "empty": "呢位病患暫無匯入文件。",
    "loadError": "無法載入匯入。",
    "received": "接收",
    "docType": "類型",
    "status": "狀態",
    "pending": "待處理",
    "entries": "條目",
    "match": "相符",
    "mismatch": "ID 不相符",
    "statuses": {
      "pending": "待處理",
      "reviewed": "已審核",
      "dismissed": "已忽略"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "轉診單",
      "discharge-summary": "出院摘要",
      "other": "其他"
    }
  },
  "ccdaReview": {
    "title": "匯入 #{{id}}",
    "back": "返回匯入清單",
    "loadError": "無法載入此匯入。",
    "mismatchWarning": "傳送方識別同呢位病患唔相符。接受前請確認文件歸屬。",
    "unnamed": "未命名條目",
    "accept": "接受",
    "reject": "拒絕",
    "accepted": "條目已併入病歷",
    "rejected": "條目已拒絕",
    "alreadyReviewed": "已被他人審核 — 下方已重新整理",
    "reviewError": "審核失敗",
    "confirmAcceptTitle": "接受併入病歷?",
    "confirmAcceptMessage": "“{{name}}”將被加入呢位病患病歷中。",
    "confirmRejectTitle": "拒絕此條目?",
    "confirmRejectMessage": "“{{name}}”將自佇列移除。原始文件保留存檔。",
    "sections": {
      "problem": "問題",
      "medication": "用藥",
      "allergy": "過敏"
    },
    "statuses": {
      "accepted": "已接受",
      "rejected": "已拒絕"
    }
  }
}
